import { render, staticRenderFns } from "./SjckLCPrint.vue?vue&type=template&id=6ebcc2b3&scoped=true&"
import script from "./SjckLCPrint.vue?vue&type=script&lang=js&"
export * from "./SjckLCPrint.vue?vue&type=script&lang=js&"
import style0 from "./SjckLCPrint.vue?vue&type=style&index=0&id=6ebcc2b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebcc2b3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
